import { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import {
  SidebarProvider,
  SidebarInset,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from "@/components/ui/breadcrumb";
import { AppSidebar } from "@/components/app-sidebar";
import { PATIENT_SIDEBAR } from "@/routes";
import { useLocation } from "react-router-dom";
import { STRINGS } from "@/constants/strings";

const PatientHomePage = lazy(() => import("@/pages/patient/PatientHomePage"));
const PatientSessionPage = lazy(
  () => import("@/pages/patient/PatientSessionPage"),
);

function PageTitle() {
  const location = useLocation();
  const current = PATIENT_SIDEBAR.find((item) =>
    item.path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(item.path),
  );
  return current?.title ?? STRINGS.app.name;
}

export function PatientShell() {
  return (
    <SidebarProvider>
      <AppSidebar shell="patient" items={PATIENT_SIDEBAR} />
      <SidebarInset>
        <header className="flex h-10 shrink-0 items-center gap-2 border-b px-4">
          <SidebarTrigger className="-ml-1" />
          <Separator orientation="vertical" className="mr-2 my-auto h-4" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbPage>
                  <PageTitle />
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </header>
        <main className="flex-1 p-4 md:p-6">
          <Suspense
            fallback={
              <div className="flex items-center justify-center py-12 text-muted-foreground">
                {STRINGS.admin.loading}
              </div>
            }
          >
            <Routes>
              <Route index element={<PatientHomePage />} />
              <Route path="sessions/:id" element={<PatientSessionPage />} />
            </Routes>
          </Suspense>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
